const textToLightColor = (text: string) => {
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = text.charCodeAt(i) + ((hash << 5) - hash);
  }

  const hue = Math.abs(hash) % 360;
  const saturation = 55;
  const lightness = 70;

  const hslToHex = (h: number, s: number, l: number) => {
    s /= 100;
    l /= 100;
    const k = (n: number) => (n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n: number) =>
      l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return (
      '#' +
      [f(0), f(8), f(4)]
        .map(x =>
          Math.round(x * 255)
            .toString(16)
            .padStart(2, '0')
        )
        .join('')
    );
  };

  return hslToHex(hue, saturation, lightness);
};

const textToDarkColor = (text: string) => {
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = text.charCodeAt(i) + ((hash << 5) - hash);
  }

  const hue = Math.abs(hash) % 360;

  const saturation = 65;
  const lightness = 40;

  const hslToHex = (h: number, s: number, l: number) => {
    s /= 100;
    l /= 100;

    const k = (n: number) => (n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n: number) =>
      l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));

    return (
      '#' +
      [f(0), f(8), f(4)]
        .map(x =>
          Math.round(x * 255)
            .toString(16)
            .padStart(2, '0')
        )
        .join('')
    );
  };

  return hslToHex(hue, saturation, lightness);
};

export const textToColor = (text: string, theme: ThemeType) => {
  return theme === 'dark' ? textToDarkColor(text) : textToLightColor(text);
};
